import Model from '../Model';
import Mithril from 'mithril';


export default class HeroTagHeroLevel extends Model {
  heroIntroId() {
    return Model.attribute<number>('heroIntroId').call(this);
  }
  level() {
    return Model.attribute<number>('level').call(this);
  }
  introduction() {
    return Model.attribute<string>('introduction').call(this);
  }
}
